module.exports = __webpack_public_path__ + "img/53FT.ae6df384.svg";